import type { FC } from 'react';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

interface ResidentTransactionInfoColumnProps {
  info: string;
  serviceProvider?: string;
  width?: number;
}

export const ResidentTransactionInfoColumn: FC<
  ResidentTransactionInfoColumnProps
> = ({ info, serviceProvider, width = 150 }) => {
  const ellipsisStyles = useMemo(
    () => ({
      width,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    [width]
  );

  const serviceProviderRef = useRef<HTMLParagraphElement>(null);
  const infoRef = useRef<HTMLParagraphElement>(null);

  const [showServiceProviderTooltip, setShowServiceProviderTooltip] =
    useState(false);
  const [showInfoTooltip, setShowInfoTooltip] = useState(false);

  useLayoutEffect(() => {
    if (
      serviceProviderRef.current &&
      serviceProviderRef.current.offsetWidth <
        serviceProviderRef.current.scrollWidth
    ) {
      setShowServiceProviderTooltip(true);
    }
    if (
      infoRef.current &&
      infoRef.current.offsetWidth < infoRef.current.scrollWidth
    ) {
      setShowInfoTooltip(true);
    }
  }, []);

  if (serviceProvider) {
    return (
      <Tooltip
        arrow
        placement="top-start"
        title={
          showServiceProviderTooltip || showInfoTooltip
            ? `${info} - ${serviceProvider}`
            : undefined
        }
      >
        <div>
          <Typography
            ref={serviceProviderRef}
            variant="subtitle2"
            sx={ellipsisStyles}
          >
            {serviceProvider}
          </Typography>
          <Typography
            ref={infoRef}
            variant="subtitle2"
            sx={[
              {
                color: 'text.secondary',
              },
              ...(Array.isArray(ellipsisStyles)
                ? ellipsisStyles
                : [ellipsisStyles]),
            ]}
          >
            {info}
          </Typography>
        </div>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      arrow
      placement="top-start"
      title={showInfoTooltip ? info : undefined}
    >
      <Typography ref={infoRef} variant="subtitle2" sx={ellipsisStyles}>
        {info}
      </Typography>
    </Tooltip>
  );
};
